/**
 * @typedef {keyof typeof DIRECTION} Direction
 */

/** @enum {Direction} */
export const DIRECTION = Object.freeze({
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  UP: 'UP',
  DOWN: 'DOWN',
  NONE: 'NONE',
});
